import { SpecialArticleItemSchema } from "src/models/articles/getSpecialArticle";
import { PaginatorSchema } from "src/types/PaginatorSchema";
import { setInstanceByEnvType } from "src/utils/helpers/requestApi/isServer";

export interface LastArticlesSchema {
  articles: SpecialArticleItemSchema[];
  paginator: PaginatorSchema;
}

export interface LastArticlesParams {
  page: number;
}

export const getLastArticles = (params: LastArticlesParams) =>
  setInstanceByEnvType().get<LastArticlesSchema>("/blog/articles", { params });
